// YMM Verify Widget V4 – Multi-tag URLs, required fields verify + custom product filters
(function(){
    // Boot guard: on the mobile-1c swapped PDP (sections/jug-mobile-1c) this file
    // can be executed twice — the classic page's queued deferred copy plus the
    // stamped 1c copy. Double-init double-binds the delegated ATC click (the #105
    // double-add class of bug), so only the first execution proceeds.
    if(window.__jugYmmVerifyBooted) return;
    var root = document.getElementById('ymm-verify');
    if(!root) return;
    window.__jugYmmVerifyBooted = true;

    // Y5: flag body.ymm-active while the widget has focus so the theme can
    // suppress the Klaviyo popup / $15 teaser during fitment interaction.
    root.addEventListener('focusin', function(){ document.body.classList.add('ymm-active'); });
    root.addEventListener('focusout', function(e){
      if(!root.contains(e.relatedTarget)) document.body.classList.remove('ymm-active');
    });

    // Y4: delegated Add-to-Cart CTA click (root survives innerHTML re-renders).
    root.addEventListener('click', function(e){
      var cta = e.target && e.target.closest ? e.target.closest('.ymm-v3-fit-cta') : null;
      if(cta){ e.preventDefault(); triggerAddToCart(); }
    });

    var productGid = root.getAttribute('data-product-gid');
    var heading = root.getAttribute('data-heading') || 'Verify Your Vehicle';

    function variantUrl(vid){
      // Set ONLY the variant param. Rebuilding from pathname discarded every
      // other query param — wiping utm_*/gclid/fbclid (breaking attribution on
      // the highest-intent sessions) and ?view= (breaking template previews).
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', vid);
        return u.pathname + u.search + u.hash;
      } catch (e) {
        return window.location.pathname + '?variant=' + vid;
      }
    }

    function selectVariant(vid){
      // Record our own picks so the variant monitor can tell a programmatic
      // change from a USER's manual variant click (user picks must never be
      // auto-corrected — 8/10).
      window.__jugYmmProgVid = String(vid);
      var newUrl = variantUrl(vid);
      // Update URL without reload
      window.history.replaceState({}, '', newUrl);
      // Update hidden variant input so add-to-cart uses the right variant
      var hiddenInputs = document.querySelectorAll('input[name="id"]');
      hiddenInputs.forEach(function(el){ el.value = vid; });
      // Also update select elements if the theme uses them
      var selects = document.querySelectorAll('select option[value="' + vid + '"]');
      selects.forEach(function(el){
        el.parentElement.value = vid;
        el.parentElement.dispatchEvent(new Event('change', { bubbles: true }));
      });
      // Dispatch events that themes commonly listen for
      window.dispatchEvent(new PopStateEvent('popstate', { state: {} }));
      try {
        document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: { id: parseInt(vid, 10) } }, bubbles: true }));
      } catch(e){}
    }

    if(!productGid){
      var pid = (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product && ShopifyAnalytics.meta.product.id)
        || (window.meta && window.meta.product && window.meta.product.id);
      if(pid){
        productGid = 'gid://shopify/Product/' + pid;
      }
    }

    var hasSavedVehicle = false;
    try {
      var saved = sessionStorage.getItem('ymm_vehicle_selection');
      hasSavedVehicle = !!(saved && productGid);
    } catch(e){}

    // ── CSS ──
    var css = '\n'
      + '.ymm-v3-widget{font-family:"Barlow",sans-serif;color:#fff}\n'
      + '.ymm-v3-fitment-prompt{display:flex;align-items:center;gap:14px;background:rgba(255,165,0,0.06);border:1px solid rgba(255,165,0,0.2);border-radius:6px;padding:14px 16px;margin-bottom:14px}\n'
      + '.ymm-v3-fitment-prompt__icon{width:42px;height:42px;border-radius:8px;background:rgba(255,165,0,0.12);display:flex;align-items:center;justify-content:center;flex-shrink:0}\n'
      + '.ymm-v3-fitment-prompt__icon svg{width:22px;height:22px;color:#FFA500}\n'
      + '.ymm-v3-fitment-prompt__title{font-family:"Oswald",sans-serif;font-size:16px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:#fff;margin-bottom:2px}\n'
      + '.ymm-v3-fitment-prompt__sub{font-family:"Barlow Condensed",sans-serif;font-size:13px;font-weight:500;letter-spacing:0.5px;color:#bbb;line-height:1.4}\n'
      + '.ymm-v3-fitment-selects{display:grid;grid-template-columns:repeat(auto-fit,minmax(100px,1fr));gap:8px;margin-bottom:8px}\n'
      + '.ymm-v3-fitment-select{background:#111;border:1px solid rgba(255,255,255,0.12);border-radius:4px;padding:10px 32px 10px 12px;color:#666;font-family:"Barlow",sans-serif;font-size:13px;appearance:none;cursor:pointer;width:100%;background-image:url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'12\' height=\'8\' fill=\'none\'%3E%3Cpath d=\'M1 1.5L6 6.5L11 1.5\' stroke=\'%23FFA500\' stroke-width=\'2\' stroke-linecap=\'round\'/%3E%3C/svg%3E");background-repeat:no-repeat;background-position:right 10px center}\n'
      + '.ymm-v3-fitment-select.active{color:#fff;border-color:#FFA500}\n'
      // Disabled selects: pointer-events:none lets the tap pass through to
      // the .ymm-v3-field wrapper so the locked-field hint can fire (a
      // disabled <select> otherwise silently swallows the tap = dead click).
      + '.ymm-v3-fitment-select:disabled{opacity:0.35;cursor:not-allowed;pointer-events:none}\n'
      + '.ymm-v3-fitment-select option{background:#111;color:#fff}\n'
      // Field wrapper + locked-field tap hint
      + '.ymm-v3-field{position:relative;min-width:0}\n'
      // Tooltip, not a bar: the old full-width orange pill under the tapped
      // field read as a BUTTON and overlapped the field below it. This is a
      // small dark bubble with a caret, floating ABOVE the field the user
      // should fill (see showFieldHint — it anchors to the first empty field,
      // not the tapped one), sized to its text.
      + '.ymm-v3-field__hint{position:absolute;left:50%;bottom:calc(100% + 8px);top:auto;z-index:6;background:#26262b;color:#f6f6f4;border:1px solid rgba(255,255,255,0.14);box-shadow:0 4px 14px rgba(0,0,0,0.45);font-family:"Barlow",sans-serif;font-size:12.5px;font-weight:600;letter-spacing:0.2px;text-transform:none;text-align:center;padding:7px 12px;border-radius:6px;opacity:0;transform:translateX(-50%) translateY(4px);transition:opacity .2s,transform .2s;pointer-events:none;white-space:nowrap}\n'
      + '.ymm-v3-field__hint::after{content:"";position:absolute;top:100%;left:50%;transform:translateX(-50%);border:5px solid transparent;border-top-color:#26262b}\n'
      + '.ymm-v3-field__hint--show{opacity:1;transform:translateX(-50%) translateY(0)}\n'
      + '@keyframes ymm-v3-unlock{0%{border-color:#FFA500;box-shadow:0 0 0 2px rgba(255,165,0,0.25)}100%{border-color:rgba(255,255,255,0.12);box-shadow:none}}\n'
      + '.ymm-v3-fitment-select.ymm-just-unlocked{animation:ymm-v3-unlock .5s ease-out}\n'
      // Y4: verified -> add-to-cart CTA (makes verification a doorway, not an endpoint)
      + '.ymm-v3-fit-cta{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;margin-top:10px;padding:14px 20px;background:#22c55e;border:none;border-radius:6px;font-family:"Oswald",sans-serif;font-size:15px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:#062e16;cursor:pointer;transition:background .2s}\n'
      + '.ymm-v3-fit-cta:hover{background:#16a34a}\n'
      + '.ymm-v3-fit-cta svg{width:18px;height:18px}\n'
      // Load error + retry state (replaces the dead skeleton on fetch failure)
      + '.ymm-v3-error{text-align:center;padding:24px 20px}\n'
      + '.ymm-v3-error__text{font-family:"Barlow Condensed",sans-serif;font-size:14px;letter-spacing:0.5px;color:#bbb;margin-bottom:14px;line-height:1.5}\n'
      + '.ymm-v3-error__retry{display:inline-flex;align-items:center;justify-content:center;gap:6px;padding:10px 22px;background:rgba(255,165,0,0.12);border:1.5px solid rgba(255,165,0,0.4);border-radius:6px;font-family:"Oswald",sans-serif;font-size:13px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:#FFA500;cursor:pointer;transition:all .2s}\n'
      + '.ymm-v3-error__retry:hover{background:rgba(255,165,0,0.2);border-color:#FFA500}\n'
      // Loading
      + '.ymm-v3-loading{text-align:center;padding:30px 20px}\n'
      + '.ymm-v3-spinner{display:inline-block;width:32px;height:32px;border:3px solid rgba(255,165,0,0.15);border-top-color:#FFA500;border-radius:50%;animation:ymm-v3-spin 0.8s linear infinite}\n'
      + '@keyframes ymm-v3-spin{to{transform:rotate(360deg)}}\n'
      + '.ymm-v3-loading-text{margin-top:12px;font-family:"Barlow Condensed",sans-serif;font-size:13px;letter-spacing:2px;text-transform:uppercase;color:#888}\n'
      // Vehicle confirmed banner
      + '.ymm-v3-vehicle-confirmed{display:flex;align-items:center;gap:14px;background:rgba(34,197,94,0.06);border:1px solid rgba(34,197,94,0.2);border-radius:6px;padding:14px 16px}\n'
      + '.ymm-v3-vehicle-confirmed__icon{width:40px;height:40px;border-radius:8px;background:rgba(34,197,94,0.12);display:flex;align-items:center;justify-content:center;flex-shrink:0}\n'
      + '.ymm-v3-vehicle-confirmed__icon svg{width:22px;height:22px;color:#22c55e}\n'
      + '.ymm-v3-vehicle-confirmed__info{flex:1;min-width:0}\n'
      + '.ymm-v3-vehicle-confirmed__label{font-family:"Barlow Condensed",sans-serif;font-size:13px;font-weight:600;letter-spacing:2px;text-transform:uppercase;color:#22c55e;margin-bottom:3px}\n'
      + '.ymm-v3-vehicle-confirmed__name{font-family:"Oswald",sans-serif;font-size:18px;font-weight:700;letter-spacing:1px;text-transform:uppercase;color:#fff}\n'
      + '.ymm-v3-vehicle-confirmed__change{display:flex;align-items:center;gap:4px;background:none;border:1px solid rgba(34,197,94,0.3);border-radius:6px;padding:8px 14px;font-family:"Barlow Condensed",sans-serif;font-size:13px;font-weight:600;letter-spacing:1.5px;text-transform:uppercase;color:#22c55e;cursor:pointer;transition:all 0.2s;white-space:nowrap}\n'
      + '.ymm-v3-vehicle-confirmed__change:hover{border-color:#22c55e;background:rgba(34,197,94,0.08)}\n'
      + '.ymm-v3-vehicle-confirmed__change svg{width:12px;height:12px}\n'
      // Pending variant (custom filter selection needed)
      + '.ymm-v3-vehicle-confirmed--pending{background:rgba(255,165,0,0.04);border-color:rgba(255,165,0,0.2)}\n'
      + '.ymm-v3-vehicle-confirmed--pending .ymm-v3-vehicle-confirmed__icon{background:rgba(255,165,0,0.12)}\n'
      + '.ymm-v3-vehicle-confirmed--pending .ymm-v3-vehicle-confirmed__icon svg{color:#FFA500}\n'
      + '.ymm-v3-vehicle-confirmed--pending .ymm-v3-vehicle-confirmed__label{color:#FFA500}\n'
      + '.ymm-v3-vehicle-confirmed--pending .ymm-v3-vehicle-confirmed__change{border-color:rgba(255,165,0,0.3);color:#FFA500}\n'
      + '.ymm-v3-vehicle-confirmed--pending .ymm-v3-vehicle-confirmed__change:hover{background:rgba(255,165,0,0.08);border-color:#FFA500}\n'
      // No-fit variant
      + '.ymm-v3-vehicle-confirmed--nofit{background:rgba(255,255,255,0.03);border-color:rgba(255,255,255,0.1)}\n'
      + '.ymm-v3-vehicle-confirmed--nofit .ymm-v3-vehicle-confirmed__icon{background:rgba(255,255,255,0.06)}\n'
      + '.ymm-v3-vehicle-confirmed--nofit .ymm-v3-vehicle-confirmed__icon svg{color:#F87171}\n'
      + '.ymm-v3-vehicle-confirmed--nofit .ymm-v3-vehicle-confirmed__label{color:#F87171 !important}\n'
      + '.ymm-v3-vehicle-confirmed--nofit .ymm-v3-vehicle-confirmed__change{border-color:rgba(255,165,0,0.3);color:#FFA500}\n'
      + '.ymm-v3-vehicle-confirmed--nofit .ymm-v3-vehicle-confirmed__change:hover{background:rgba(255,165,0,0.08);border-color:#FFA500}\n'
      // Warn variant (selected config doesn't fit but others do)
      + '.ymm-v3-vehicle-confirmed--warn{background:rgba(255,165,0,0.05);border-color:rgba(255,165,0,0.25)}\n'
      + '.ymm-v3-vehicle-confirmed--warn .ymm-v3-vehicle-confirmed__icon{background:rgba(255,165,0,0.12)}\n'
      + '.ymm-v3-vehicle-confirmed--warn .ymm-v3-vehicle-confirmed__icon svg{color:#FFA500}\n'
      + '.ymm-v3-vehicle-confirmed--warn .ymm-v3-vehicle-confirmed__label{color:#FFA500}\n'
      + '.ymm-v3-vehicle-confirmed--warn .ymm-v3-vehicle-confirmed__change{border-color:rgba(255,165,0,0.3);color:#FFA500}\n'
      + '.ymm-v3-vehicle-confirmed--warn .ymm-v3-vehicle-confirmed__change:hover{background:rgba(255,165,0,0.08);border-color:#FFA500}\n'
      // Fitting option buttons
      + '.ymm-v3-fitting-options{display:flex;flex-wrap:wrap;gap:8px;margin-top:10px}\n'
      + '.ymm-v3-fitting-option-btn{display:flex;align-items:center;justify-content:center;gap:6px;width:100%;padding:10px 16px;background:rgba(34,197,94,0.08);border:1.5px solid rgba(34,197,94,0.3);border-radius:6px;font-family:"Barlow Condensed",sans-serif;font-size:14px;font-weight:600;letter-spacing:0.8px;text-transform:uppercase;color:#22c55e;cursor:pointer;transition:all 0.2s}\n'
      + '.ymm-v3-fitting-option-btn:hover{background:rgba(34,197,94,0.15);border-color:#22c55e}\n'
      + '.ymm-v3-fitting-option-btn svg{width:14px;height:14px;flex-shrink:0}\n'
      // Coming soon variant
      + '.ymm-v3-vehicle-confirmed--coming-soon{background:rgba(59,130,246,0.05);border-color:rgba(59,130,246,0.25)}\n'
      + '.ymm-v3-vehicle-confirmed--coming-soon .ymm-v3-vehicle-confirmed__icon{background:rgba(59,130,246,0.12)}\n'
      + '.ymm-v3-vehicle-confirmed--coming-soon .ymm-v3-vehicle-confirmed__icon svg{color:#3b82f6}\n'
      + '.ymm-v3-vehicle-confirmed--coming-soon .ymm-v3-vehicle-confirmed__label{color:#3b82f6}\n'
      + '.ymm-v3-vehicle-confirmed--coming-soon .ymm-v3-vehicle-confirmed__change{border-color:rgba(59,130,246,0.3);color:#3b82f6}\n'
      + '.ymm-v3-vehicle-confirmed--coming-soon .ymm-v3-vehicle-confirmed__change:hover{background:rgba(59,130,246,0.08);border-color:#3b82f6}\n'
      + '.ymm-v3-coming-soon-card{background:rgba(59,130,246,0.05);border:1px solid rgba(59,130,246,0.2);border-radius:6px;padding:14px 16px;margin-top:10px}\n'
      + '.ymm-v3-coming-soon-card__title{font-family:"Oswald",sans-serif;font-size:14px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:#3b82f6;margin-bottom:4px}\n'
      + '.ymm-v3-coming-soon-card__text{font-family:"Barlow Condensed",sans-serif;font-size:13px;color:#94a3b8;margin-bottom:10px;letter-spacing:0.3px}\n'
      + '.ymm-v3-coming-soon-card__form{display:flex;gap:8px}\n'
      + '.ymm-v3-coming-soon-card__input{flex:1;padding:9px 12px;border:1px solid rgba(255,255,255,0.12);border-radius:4px;background:#111;color:#fff;font-size:13px;font-family:"Barlow",sans-serif}\n'
      + '.ymm-v3-coming-soon-card__input::placeholder{color:#666}\n'
      + '.ymm-v3-coming-soon-card__input:focus{outline:none;border-color:#3b82f6}\n'
      + '.ymm-v3-coming-soon-card__btn{padding:9px 16px;border:none;border-radius:4px;background:#3b82f6;color:#fff;font-family:"Barlow Condensed",sans-serif;font-size:13px;font-weight:600;letter-spacing:1px;text-transform:uppercase;cursor:pointer;transition:background 0.2s;white-space:nowrap}\n'
      + '.ymm-v3-coming-soon-card__btn:hover{background:#2563eb}\n'
      + '.ymm-v3-coming-soon-card__btn:disabled{opacity:0.6;cursor:not-allowed}\n'
      + '.ymm-v3-coming-soon-card__success{color:#22c55e;font-family:"Barlow Condensed",sans-serif;font-size:13px;letter-spacing:0.5px;padding:4px 0}\n'
      // Result banners
      + '.ymm-v3-fitment-result{display:flex;align-items:center;gap:10px;padding:12px 16px;border-radius:6px;font-family:"Barlow Condensed",sans-serif;font-size:14px;letter-spacing:0.8px;text-transform:uppercase;font-weight:600;margin-top:10px}\n'
      + '.ymm-v3-fitment-result svg{width:18px;height:18px;flex-shrink:0}\n'
      + '.ymm-v3-fitment-result--no-fit{background:rgba(255,255,255,0.04);border:1px solid rgba(255,255,255,0.1);color:#d4d4d4}\n'
      + '.ymm-v3-fitment-result__text{flex:1}\n'
      // Browse CTA
      + '.ymm-v3-fitment-browse-btn{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;margin-top:12px;padding:12px 20px;background:rgba(255,165,0,0.1);border:1.5px solid rgba(255,165,0,0.35);border-radius:6px;font-family:"Oswald",sans-serif;font-size:14px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:#FFA500;cursor:pointer;text-decoration:none;transition:all 0.2s}\n'
      + '.ymm-v3-fitment-browse-btn:hover{background:rgba(255,165,0,0.18);border-color:#FFA500}\n'
      + '.ymm-v3-fitment-browse-btn svg{width:16px;height:16px;flex-shrink:0}\n'
      // Upsell card
      + '.ymm-v3-upsell-card{margin-top:10px;background:rgba(255,165,0,0.05);border:1px dashed rgba(255,165,0,0.3);border-radius:6px;padding:12px 14px}\n'
      + '.ymm-v3-upsell-card__header{font-family:"Oswald",sans-serif;font-size:14px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:#FFA500;margin-bottom:6px}\n'
      + '.ymm-v3-upsell-card__text{font-size:14px;color:#bbb;line-height:1.5;margin-bottom:8px}\n'
      + '.ymm-v3-upsell-card__link{display:inline-flex;align-items:center;gap:6px;font-family:"Oswald",sans-serif;font-size:14px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:#FFA500;cursor:pointer;text-decoration:underline;text-underline-offset:3px}\n'
      + '.ymm-v3-upsell-card__link:hover{color:#E89400}\n'
      + '.ymm-v3-upsell-card__link svg{width:14px;height:14px}\n'
      // Bundle card
      + '.ymm-v3-bundle-card{margin-top:10px;background:rgba(255,165,0,0.04);border:2px solid rgba(255,165,0,0.25);border-radius:6px;padding:16px;overflow:hidden;text-decoration:none;display:block;transition:all 0.2s;cursor:pointer}\n'
      + '.ymm-v3-bundle-card:hover{border-color:#FFA500;background:rgba(255,165,0,0.08)}\n'
      + '.ymm-v3-bundle-card__badge{display:inline-flex;align-items:center;gap:5px;background:#FFA500;color:#000;font-family:"Oswald",sans-serif;font-size:12px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;padding:4px 10px;border-radius:3px;margin-bottom:10px}\n'
      + '.ymm-v3-bundle-card__badge svg{width:14px;height:14px}\n'
      + '.ymm-v3-bundle-card__title{font-family:"Oswald",sans-serif;font-size:16px;font-weight:700;letter-spacing:1px;text-transform:uppercase;color:#fff;margin-bottom:6px}\n'
      + '.ymm-v3-bundle-card__desc{font-size:14px;color:#bbb;line-height:1.5;margin-bottom:10px}\n'
      + '.ymm-v3-bundle-card__pricing{display:flex;align-items:center;gap:10px;flex-wrap:wrap}\n'
      + '.ymm-v3-bundle-card__price-new{font-family:"Oswald",sans-serif;font-size:22px;font-weight:700;color:#22c55e}\n'
      + '.ymm-v3-bundle-card__price-old{font-size:15px;color:#bbb;text-decoration:line-through}\n'
      + '.ymm-v3-bundle-card__savings{display:inline-flex;align-items:center;gap:4px;background:rgba(34,197,94,0.15);color:#22c55e;font-family:"Barlow Condensed",sans-serif;font-size:13px;font-weight:700;letter-spacing:1px;text-transform:uppercase;padding:4px 10px;border-radius:3px}\n'
      + '.ymm-v3-bundle-card__cta{display:flex;align-items:center;justify-content:center;gap:8px;margin-top:12px;padding:12px 20px;background:rgba(255,165,0,0.12);border:1px solid rgba(255,165,0,0.3);border-radius:6px;font-family:"Oswald",sans-serif;font-size:14px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:#FFA500}\n'
      + '.ymm-v3-bundle-card__cta svg{width:16px;height:16px}\n'
      // Refinement prompt (custom filter)
      + '.ymm-v3-refinement{margin-top:10px;background:rgba(255,165,0,0.05);border:1px solid rgba(255,165,0,0.2);border-radius:6px;padding:14px 16px}\n'
      + '.ymm-v3-refinement__header{display:flex;align-items:center;gap:10px;margin-bottom:10px}\n'
      + '.ymm-v3-refinement__icon{width:32px;height:32px;border-radius:6px;background:rgba(255,165,0,0.12);display:flex;align-items:center;justify-content:center;flex-shrink:0}\n'
      + '.ymm-v3-refinement__icon svg{width:16px;height:16px;color:#FFA500}\n'
      + '.ymm-v3-refinement__title{font-family:"Oswald",sans-serif;font-size:14px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:#FFA500}\n'
      + '.ymm-v3-refinement__sub{font-family:"Barlow Condensed",sans-serif;font-size:12px;color:#999;letter-spacing:0.5px}\n'
      + '.ymm-v3-refinement__selects{display:grid;grid-template-columns:repeat(auto-fit,minmax(120px,1fr));gap:8px}\n'
      + '.ymm-v3-confirm{margin-top:6px}\n'
      + '.ymm-v3-confirm__question{font-family:"Barlow Condensed",sans-serif;font-size:13px;color:#bbb;margin-bottom:8px;line-height:1.4;letter-spacing:0.3px}\n'
      + '.ymm-v3-confirm__value{color:#FFA500;font-weight:600;text-decoration:underline;text-underline-offset:2px}\n'
      + '.ymm-v3-confirm__buttons{display:flex;gap:8px;align-items:center}\n'
      + '.ymm-v3-confirm__btn{padding:8px 18px;border-radius:4px;font-family:"Barlow Condensed",sans-serif;font-size:13px;font-weight:600;letter-spacing:1px;text-transform:uppercase;cursor:pointer;transition:all 0.2s;text-align:center}\n'
      + '.ymm-v3-confirm__btn--yes{background:rgba(255,165,0,0.1);border:1px solid rgba(255,165,0,0.3);color:#FFA500}\n'
      + '.ymm-v3-confirm__btn--yes:hover{background:rgba(255,165,0,0.2);border-color:#FFA500}\n'
      + '.ymm-v3-confirm__btn--no{background:none;border:1px solid rgba(255,255,255,0.1);color:#777;padding:8px 14px}\n'
      + '.ymm-v3-confirm__btn--no:hover{color:#bbb;border-color:rgba(255,255,255,0.2)}\n'
      // Responsive
      + '@media (max-width:768px){.ymm-v3-fitment-selects{grid-template-columns:1fr}.ymm-v3-vehicle-confirmed{flex-wrap:wrap}.ymm-v3-vehicle-confirmed__change{width:100%;justify-content:center}.ymm-v3-refinement__selects{grid-template-columns:1fr}}\n';

    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);

    // SVG icons
    var shieldIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>';
    var checkIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6L9 17l-5-5"/></svg>';
    var infoIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>';
    var xIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    var searchIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/></svg>';
    var arrowIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"/><path d="M12 5l7 7-7 7"/></svg>';
    var bundleIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="1" y="3" width="22" height="18" rx="2"/><line x1="1" y1="9" x2="23" y2="9"/><line x1="12" y1="9" x2="12" y2="21"/></svg>';
    var tuneIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="4" y1="21" x2="4" y2="14"/><line x1="4" y1="10" x2="4" y2="3"/><line x1="12" y1="21" x2="12" y2="12"/><line x1="12" y1="8" x2="12" y2="3"/><line x1="20" y1="21" x2="20" y2="16"/><line x1="20" y1="12" x2="20" y2="3"/><line x1="1" y1="14" x2="7" y2="14"/><line x1="9" y1="8" x2="15" y2="8"/><line x1="17" y1="16" x2="23" y2="16"/></svg>';
    var clockIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>';

    function formatPrice(val){
      if(!val) return '';
      val = String(val).replace(/^\$/, '');
      var num = parseFloat(val);
      if(isNaN(num)) return val;
      return '$' + num.toFixed(2);
    }

    function dispatchFitmentChange(state, vehicle){
      document.dispatchEvent(new CustomEvent('ymm:fitment-change', {
        detail: { state: state, vehicle: vehicle || '' }
      }));
      // Y4: dedicated structured event on a confirmed fit so the theme can
      // render its own "✓ Fits your … — Add to Cart · $XXX" CTA with price.
      if(state === 'fits'){
        var fields = null;
        try { fields = JSON.parse(sessionStorage.getItem('ymm_vehicle_selection') || 'null'); } catch(e){}
        document.dispatchEvent(new CustomEvent('ymm:verified', {
          detail: { vehicle: vehicle || '', fields: fields }
        }));
      }
    }

    // Y4: in-widget Add-to-Cart CTA + trigger. The CTA fires the theme's own
    // ATC (so its cart drawer / analytics run); falls back to scrolling the
    // add-to-cart form into view if no submit button is found.
    function buildFitCTA(){
      return '<button type="button" class="ymm-v3-fit-cta">' + checkIcon + ' Add to Cart</button>';
    }
    function triggerAddToCart(){
      var btn = document.querySelector('form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] button[name="add"], form[action*="/cart/add"] [data-add-to-cart]');
      if(btn){ btn.click(); return; }
      var form = document.querySelector('form[action*="/cart/add"]');
      if(form && form.scrollIntoView){ form.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    }

    // Build initial widget HTML.
    // Y3: the prompt (with the dropdowns) is ALWAYS rendered — hidden when a
    // vehicle was restored on load — so "Change" can re-show the pre-filled,
    // editable dropdowns (edit-in-place) instead of wiping and reloading.
    var html = '<div class="ymm-v3-widget">';

    html += '<div id="ymm-v3-prompt"' + (hasSavedVehicle ? ' style="display:none"' : '') + '>';
    html += '<div class="ymm-v3-fitment-prompt">';
    html += '<div class="ymm-v3-fitment-prompt__icon">' + shieldIcon + '</div>';
    html += '<div>';
    html += '<div class="ymm-v3-fitment-prompt__title">' + heading + '</div>';
    html += '<div class="ymm-v3-fitment-prompt__sub">Confirm fitment to ensure a perfect match for your truck</div>';
    html += '</div>';
    html += '</div>';
    html += '<div class="ymm-v3-fitment-selects" id="ymm-v3-selects"></div>';
    html += '</div>';

    if(hasSavedVehicle){
      html += '<div id="ymm-v3-loading" class="ymm-v3-loading">';
      html += '<div class="ymm-v3-spinner"></div>';
      html += '<div class="ymm-v3-loading-text">Checking fitment...</div>';
      html += '</div>';
    }

    html += '<div id="ymm-v3-result" style="display:none"></div>';
    html += '</div>';

    // Shell render is a function so the retry path can rebuild it and
    // re-capture element refs (renderVehiclesError replaces root.innerHTML,
    // which would otherwise leave these refs pointing at detached nodes).
    var promptEl, loadingEl, resultEl, selectsContainer;
    function renderShell(){
      root.innerHTML = html;
      var widgetEl = root.querySelector('.ymm-v3-widget');
      if(widgetEl) widgetEl.classList.add('ymm-v3-animate-in');
      promptEl = root.querySelector('#ymm-v3-prompt');
      loadingEl = root.querySelector('#ymm-v3-loading');
      resultEl = root.querySelector('#ymm-v3-result');
      selectsContainer = root.querySelector('#ymm-v3-selects');
    }
    renderShell();

    if(!hasSavedVehicle){
      dispatchFitmentChange('none');
    }

    function showLoading(){
      if(promptEl) promptEl.style.display = 'none';
      if(!loadingEl){
        loadingEl = document.createElement('div');
        loadingEl.id = 'ymm-v3-loading';
        loadingEl.className = 'ymm-v3-loading';
        loadingEl.innerHTML = '<div class="ymm-v3-spinner"></div><div class="ymm-v3-loading-text">Checking fitment...</div>';
        root.querySelector('.ymm-v3-widget').insertBefore(loadingEl, resultEl);
      }
      loadingEl.style.display = '';
      resultEl.style.display = 'none';
    }

    // Auto-expand the theme's collapsible fitment section (a native
    // <details>) the first time a fitment verdict is shown, so a shopper who
    // lands on a PDP with a confirmed vehicle sees "Guaranteed to Fit" without
    // having to expand it. Only fires once, so a manual collapse stays.
    var accordionAutoExpanded = false;
    function expandFitmentAccordion(){
      if(accordionAutoExpanded) return;
      accordionAutoExpanded = true;
      try {
        var d = root.closest ? root.closest('details') : null;
        if(d && !d.open) d.open = true;
      } catch(e){}
    }

    function showResult(html){
      if(promptEl) promptEl.style.display = 'none';
      if(loadingEl) loadingEl.style.display = 'none';
      resultEl.innerHTML = html;
      resultEl.style.display = '';
      resultEl.classList.remove('ymm-v3-animate-in');
      void resultEl.offsetWidth;
      resultEl.classList.add('ymm-v3-animate-in');
      expandFitmentAccordion();
    }

    function resetForm(){
      try {
        sessionStorage.removeItem('ymm_vehicle_selection');
        // Clear all custom filter selections
        var keysToRemove = [];
        for(var i = 0; i < localStorage.length; i++){
          var k = localStorage.key(i);
          if(k && k.indexOf('ymm_custom_filter_') === 0) keysToRemove.push(k);
        }
        keysToRemove.forEach(function(k){ localStorage.removeItem(k); });
      } catch(e){}
      window.location.reload();
    }

    // Y3: edit-in-place. Re-show the pre-filled, editable dropdowns instead
    // of wiping. The selects are always built (and restored on load), so they
    // keep the current vehicle; changing a field resets only downstream and
    // re-verifies via the existing cascade.
    function editVehicle(){
      if(loadingEl) loadingEl.style.display = 'none';
      if(resultEl) resultEl.style.display = 'none';
      if(promptEl) promptEl.style.display = '';
    }

    function bindChangeButtons(){
      root.querySelectorAll('.ymm-v3-change-trigger').forEach(function(el){
        el.addEventListener('click', function(){ editVehicle(); });
      });
    }

    // Build vehicle label from saved values
    function buildVehicleLabel(selections, requiredKeys, allFieldKeys){
      var parts = [];
      requiredKeys.forEach(function(k){ if(selections[k]) parts.push(selections[k]); });
      allFieldKeys.forEach(function(k){
        if(requiredKeys.indexOf(k) === -1 && selections[k]) parts.push(selections[k]);
      });
      return parts.join(' ');
    }

    // Build multi-line vehicle name HTML: Year Make Model Drive / Engine / extra
    function buildVehicleNameHTML(selections, requiredKeys, allFieldKeys, extraLine){
      // Line 1: Year, Make, Model, Drive (first 4 required fields)
      var line1Parts = [];
      var otherLines = [];
      requiredKeys.forEach(function(k, i){
        if(!selections[k]) return;
        if(i < 4) line1Parts.push(selections[k]);
        else otherLines.push(selections[k]);
      });
      allFieldKeys.forEach(function(k){
        if(requiredKeys.indexOf(k) === -1 && selections[k]) otherLines.push(selections[k]);
      });
      var html = '<div>' + line1Parts.join(' ') + '</div>';
      otherLines.forEach(function(line){ html += '<div>' + line + '</div>'; });
      if(extraLine) html += '<div>' + extraLine + '</div>';
      return html;
    }

    function buildConfirmedHTML(vehicleLabel, vehicleNameHTML){
      return '<div class="ymm-v3-vehicle-confirmed">'
        + '<div class="ymm-v3-vehicle-confirmed__icon">' + checkIcon + '</div>'
        + '<div class="ymm-v3-vehicle-confirmed__info">'
        + '<div class="ymm-v3-vehicle-confirmed__label">Guaranteed to Fit</div>'
        + '<div class="ymm-v3-vehicle-confirmed__name">' + (vehicleNameHTML || vehicleLabel) + '</div>'
        + '</div>'
        + '<button class="ymm-v3-vehicle-confirmed__change ymm-v3-change-trigger">Change ' + xIcon + '</button>'
        + '</div>';
    }

    function buildPendingHTML(vehicleLabel, vehicleNameHTML){
      return '<div class="ymm-v3-vehicle-confirmed ymm-v3-vehicle-confirmed--pending">'
        + '<div class="ymm-v3-vehicle-confirmed__icon">' + shieldIcon + '</div>'
        + '<div class="ymm-v3-vehicle-confirmed__info">'
        + '<div class="ymm-v3-vehicle-confirmed__label">Vehicle Detected</div>'
        + '<div class="ymm-v3-vehicle-confirmed__name">' + (vehicleNameHTML || vehicleLabel) + '</div>'
        + '</div>'
        + '<button class="ymm-v3-vehicle-confirmed__change ymm-v3-change-trigger">Change ' + xIcon + '</button>'
        + '</div>';
    }

    function buildNoFitHTML(vehicleLabel){
      return '<div class="ymm-v3-vehicle-confirmed ymm-v3-vehicle-confirmed--nofit">'
        + '<div class="ymm-v3-vehicle-confirmed__icon">' + infoIcon + '</div>'
        + '<div class="ymm-v3-vehicle-confirmed__info">'
        + '<div class="ymm-v3-vehicle-confirmed__label">Not Compatible</div>'
        + '<div class="ymm-v3-vehicle-confirmed__name">' + vehicleLabel + '</div>'
        + '</div>'
        + '<button class="ymm-v3-vehicle-confirmed__change ymm-v3-change-trigger">Change ' + xIcon + '</button>'
        + '</div>';
    }

    function buildComingSoonHTML(vehicleLabel, message, browseUrl){
      var h = '<div class="ymm-v3-vehicle-confirmed ymm-v3-vehicle-confirmed--coming-soon">'
        + '<div class="ymm-v3-vehicle-confirmed__icon">' + clockIcon + '</div>'
        + '<div class="ymm-v3-vehicle-confirmed__info">'
        + '<div class="ymm-v3-vehicle-confirmed__label">Coming Soon</div>'
        + '<div class="ymm-v3-vehicle-confirmed__name">' + vehicleLabel + '</div>'
        + '</div>'
        + '<button class="ymm-v3-vehicle-confirmed__change ymm-v3-change-trigger">Change ' + xIcon + '</button>'
        + '</div>';
      h += '<div class="ymm-v3-coming-soon-card">';
      h += '<div class="ymm-v3-coming-soon-card__title">A version for your truck is coming soon</div>';
      h += '<div class="ymm-v3-coming-soon-card__text">' + (message || 'Get notified when this product becomes available for your vehicle') + '</div>';
      h += '<div class="ymm-v3-coming-soon-card__form" id="ymm-v3-coming-soon-form">';
      h += '<input type="email" class="ymm-v3-coming-soon-card__input" placeholder="Enter your email" id="ymm-v3-coming-soon-email">';
      h += '<button class="ymm-v3-coming-soon-card__btn" id="ymm-v3-coming-soon-btn">Notify Me</button>';
      h += '</div>';
      h += '</div>';
      if(browseUrl){
        h += '<a href="' + browseUrl + '" class="ymm-v3-fitment-browse-btn">';
        h += searchIcon + ' View Products That Fit Your Vehicle ' + arrowIcon;
        h += '</a>';
      }
      return h;
    }

    var shop = window.Shopify && window.Shopify.shop ? window.Shopify.shop : '';
    var vehiclesUrl = '/apps/ymm/vehicles?allFields=true' + (shop ? '&shop=' + encodeURIComponent(shop) : '');
    var vehiclesCacheKey = 'ymm_vehicle_tree_' + (shop || 'default');

    // ── Robust vehicle-tree loader ──────────────────────────────────────
    // The whole tree comes down in ONE fetch and the cascade filters it
    // client-side (no per-field requests). A hung fetch used to leave the
    // widget on a dead skeleton forever — the "60-second stall" in session
    // replays. Fix: sessionStorage cache (instant repeat/back-nav loads) →
    // fetch with a 10s timeout + one retry → explicit tap-to-retry on final
    // failure instead of a silent dead skeleton.
    function fetchVehiclesOnce(timeoutMs){
      return new Promise(function(resolve, reject){
        var controller = (typeof AbortController !== 'undefined') ? new AbortController() : null;
        var done = false;
        var timer = setTimeout(function(){
          if(done) return;
          done = true;
          if(controller) controller.abort();
          reject(new Error('timeout'));
        }, timeoutMs);
        fetch(vehiclesUrl, controller ? { signal: controller.signal } : undefined)
          .then(function(r){
            if(!r.ok) throw new Error('HTTP error ' + r.status);
            return r.json();
          })
          .then(function(data){ if(done) return; done = true; clearTimeout(timer); resolve(data); })
          .catch(function(err){ if(done) return; done = true; clearTimeout(timer); reject(err); });
      });
    }

    function loadVehicles(onData, onError){
      // 1. sessionStorage cache — instant hydrate, no dead mount window.
      try {
        var cached = sessionStorage.getItem(vehiclesCacheKey);
        if(cached){
          var parsed = JSON.parse(cached);
          if(parsed && parsed.vehicles){ onData(parsed); return; }
        }
      } catch(e){}
      // 2. Fetch w/ timeout, one retry, then cache on success.
      fetchVehiclesOnce(10000)
        .catch(function(){ return fetchVehiclesOnce(10000); })
        .then(function(data){
          try { sessionStorage.setItem(vehiclesCacheKey, JSON.stringify(data)); } catch(e){}
          onData(data);
        })
        .catch(function(err){ onError(err); });
    }

    function renderVehiclesError(){
      root.innerHTML = '<div class="ymm-v3-widget ymm-v3-error">'
        + '<p class="ymm-v3-error__text">Couldn\'t load fitment options — check your connection.</p>'
        + '<button class="ymm-v3-error__retry" id="ymm-v3-retry" type="button">Tap to retry</button>'
        + '</div>';
      var rb = root.querySelector('#ymm-v3-retry');
      if(rb) rb.addEventListener('click', function(){
        // Rebuild the original shell (re-captures selectsContainer etc.)
        // then re-run the loader.
        renderShell();
        startLoad();
      });
    }

    function startLoad(){ loadVehicles(handleVehiclesData, renderVehiclesError); }
    startLoad();

    function handleVehiclesData(data){
        var vehicles = data.vehicles || [];
        var fieldsMetadata = data.fields || [];

        if(vehicles.length === 0){
          root.innerHTML = '<div class="ymm-v3-widget" style="padding:20px"><p style="opacity:.7;color:#888;font-family:\'Barlow Condensed\',sans-serif;font-size:13px;letter-spacing:1px">No fitment data available.</p></div>';
          return;
        }

        if(fieldsMetadata.length === 0){
          root.innerHTML = '<div class="ymm-v3-widget" style="padding:20px"><p style="opacity:.7;color:#888;font-family:\'Barlow Condensed\',sans-serif;font-size:13px;letter-spacing:1px">No field configuration found.</p></div>';
          return;
        }

        // Only use required fields for the widget dropdowns
        var requiredFields = fieldsMetadata.filter(function(f){ return !!f.required; });
        var fieldKeys = requiredFields.map(function(f){ return f.key; });
        var allFieldKeys = fieldsMetadata.map(function(f){ return f.key; });
        var fieldLabels = {};
        var fieldTypes = {};
        fieldsMetadata.forEach(function(f){
          fieldLabels[f.key] = f.label;
          fieldTypes[f.key] = f.type;
        });

        var selects = {};

        function sortValues(values, fieldKey){
          var fieldType = fieldTypes[fieldKey];
          if(fieldType === 'range'){
            return values.sort(function(a, b){
              var numA = parseFloat(a);
              var numB = parseFloat(b);
              if(isNaN(numA) || isNaN(numB)) return String(a).localeCompare(String(b));
              return numB - numA;
            });
          } else {
            return values.sort();
          }
        }

        // Locked-field tap hint: a disabled <select> swallows the tap, so
        // the tap passes through (pointer-events:none in CSS) to its wrapper,
        // which shows which field to fill first. This turns the dead click
        // into visible feedback.
        var hintTimer = null;
        function showFieldHint(fieldEl, msg){
          var existing = fieldEl.querySelector('.ymm-v3-field__hint');
          if(existing && existing.parentNode) existing.parentNode.removeChild(existing);
          var hint = document.createElement('div');
          hint.className = 'ymm-v3-field__hint';
          hint.textContent = msg;
          fieldEl.appendChild(hint);
          void hint.offsetWidth; // reflow so the transition runs
          hint.classList.add('ymm-v3-field__hint--show');
          if(hintTimer) clearTimeout(hintTimer);
          hintTimer = setTimeout(function(){
            hint.classList.remove('ymm-v3-field__hint--show');
            setTimeout(function(){ if(hint.parentNode) hint.parentNode.removeChild(hint); }, 250);
          }, 1800);
        }

        // Create required field selects (each wrapped in a .ymm-v3-field)
        if(selectsContainer){
          fieldKeys.forEach(function(key, idx){
            var field = document.createElement('div');
            field.className = 'ymm-v3-field';

            var select = document.createElement('select');
            select.className = 'ymm-v3-fitment-select';
            select.id = 'ymm-v3-' + key;
            select.disabled = idx > 0;
            // This design carries no visible <label> — the placeholder option
            // is the label. Sighted users read it; screen readers announced
            // these five as unlabeled. aria-label restores the name with no
            // visual change.
            select.setAttribute('aria-label', fieldLabels[key]);

            var defaultOption = document.createElement('option');
            defaultOption.value = '';
            defaultOption.textContent = fieldLabels[key];
            select.appendChild(defaultOption);

            field.appendChild(select);
            selectsContainer.appendChild(field);
            selects[key] = select;

            // Tap on a locked field → hint pointing at the field to fill first.
            (function(fieldEl, sel, fieldIdx){
              fieldEl.addEventListener('pointerdown', function(){
                if(!sel.disabled){
                  // Acknowledge the tap in the DOM. Opening a native <select>
                  // picker mutates nothing, so analytics dead-click detection
                  // scored these WORKING taps as dead (the weekend
                  // "ymm-just-unlocked dead clicks" — that class was merely
                  // lingering, see animationend below). A class toggle is a
                  // mutation, so classifiers see the tap acknowledged.
                  sel.classList.add('ymm-v3-select--open');
                  return;
                }
                // Anchor the tooltip to the FIRST EMPTY field — that's the one
                // the user should touch next (tap Engine with nothing filled →
                // point at Year, not at Drive). Falls back to the tapped field
                // if somehow none is empty.
                var targetKey = null;
                for (var fi = 0; fi < fieldKeys.length; fi++) {
                  if (!selects[fieldKeys[fi]].value) { targetKey = fieldKeys[fi]; break; }
                }
                var targetEl = targetKey ? selects[targetKey].closest('.ymm-v3-field') : fieldEl;
                var label = targetKey ? fieldLabels[targetKey] : fieldLabels[fieldKeys[0]];
                showFieldHint(targetEl || fieldEl, 'Choose ' + label + ' first');
              });
              sel.addEventListener('blur',   function(){ sel.classList.remove('ymm-v3-select--open'); });
              sel.addEventListener('change', function(){ sel.classList.remove('ymm-v3-select--open'); });
              // The unlock flash class used to persist forever after its 0.5s
              // animation, which is why weekend dead-click data "carried
              // ymm-just-unlocked" on every cascade field — it meant nothing.
              // Clearing it on animationend makes the class a real signal:
              // present = actually just unlocked.
              sel.addEventListener('animationend', function(){ sel.classList.remove('ymm-just-unlocked'); });
            })(field, select, idx);
          });

          // Populate first field
          if(fieldKeys.length > 0){
            var firstKey = fieldKeys[0];
            var firstValues = Array.from(new Set(vehicles.map(function(v){return v[firstKey];}).filter(Boolean)));
            firstValues = sortValues(firstValues, firstKey);
            firstValues.forEach(function(val){
              var opt = document.createElement('option');
              opt.value = val; opt.textContent = val;
              selects[firstKey].appendChild(opt);
            });
            selects[firstKey].disabled = false;
          }
        }

        function loadSavedSelection(){
          try {
            var saved = sessionStorage.getItem('ymm_vehicle_selection');
            if(saved) return JSON.parse(saved);
          } catch(e){}
          return null;
        }

        // Only save required fields to localStorage
        function saveSelection(selections){
          try {
            var requiredOnly = {};
            fieldKeys.forEach(function(key){
              if(selections[key]) requiredOnly[key] = selections[key];
            });
            // Clear all custom filter caches when saving a new vehicle
            var cfKeysToRemove = [];
            for(var ci = 0; ci < localStorage.length; ci++){
              var ck = localStorage.key(ci);
              if(ck && ck.indexOf('ymm_custom_filter_') === 0) cfKeysToRemove.push(ck);
            }
            cfKeysToRemove.forEach(function(ck){ localStorage.removeItem(ck); });
            var hadVehicle = sessionStorage.getItem('ymm_vehicle_selection');
            sessionStorage.setItem('ymm_vehicle_selection', JSON.stringify(requiredOnly));
            if (!hadVehicle) sessionStorage.setItem('ymm_source', 'verify_widget');
          } catch(e){}
        }

        function checkAllFieldsFilled(){
          for(var i = 0; i < fieldKeys.length; i++){
            var sel = selects[fieldKeys[i]];
            if(!sel || !sel.value) return false;
          }
          return true;
        }

        function getSelections(){
          var selected = {};
          fieldKeys.forEach(function(key){
            var val = selects[key] && selects[key].value;
            if(val) selected[key] = val;
          });
          return selected;
        }

        function updateCascade(changedIndex){
          // Clear downstream fields
          for(var i = changedIndex + 1; i < fieldKeys.length; i++){
            selects[fieldKeys[i]].value = '';
          }

          // Rebuild downstream field options
          for(var i = changedIndex + 1; i < fieldKeys.length; i++){
            var key = fieldKeys[i];
            var selected = {};
            for(var j = 0; j < i; j++){
              var prevKey = fieldKeys[j];
              var prevVal = selects[prevKey].value;
              if(prevVal) selected[prevKey] = prevVal;
            }

            var allPreviousSelected = true;
            for(var j = 0; j < i; j++){
              if(!selects[fieldKeys[j]].value){ allPreviousSelected = false; break; }
            }

            selects[key].innerHTML = '';
            var defaultOpt = document.createElement('option');
            defaultOpt.value = '';
            defaultOpt.textContent = fieldLabels[key];
            selects[key].appendChild(defaultOpt);

            if(!allPreviousSelected){ selects[key].disabled = true; continue; }

            var filtered = vehicles.filter(function(v){
              for(var k in selected){ if(v[k] !== selected[k]) return false; }
              return true;
            });

            var values = Array.from(new Set(filtered.map(function(v){return v[key];}).filter(Boolean)));
            if(values.length > 0){
              values = sortValues(values, key);
              values.forEach(function(val){
                var opt = document.createElement('option');
                opt.value = val; opt.textContent = val;
                selects[key].appendChild(opt);
              });
              selects[key].disabled = false;
              // Visible unlock flash so the eye tracks the cascade.
              selects[key].classList.remove('ymm-just-unlocked');
              void selects[key].offsetWidth;
              selects[key].classList.add('ymm-just-unlocked');
              // Auto-select when there's exactly one option — skips a
              // needless tap and lets the cascade flow straight to the
              // next field (the loop below reads this value when it
              // rebuilds field i+1). If the auto-fills complete every
              // field, the checkAllFieldsFilled() block below auto-verifies.
              if(values.length === 1){
                selects[key].value = values[0];
              }
            } else {
              selects[key].disabled = true;
            }
          }

          // Update active class
          fieldKeys.forEach(function(key){
            if(selects[key].value) selects[key].classList.add('active');
            else selects[key].classList.remove('active');
          });

          // Auto-verify when all required fields are filled
          if(checkAllFieldsFilled()){
            var selected = getSelections();
            saveSelection(selected);
            savedSelections = selected;

            showLoading();

            if(!productGid){
              var vehicleLabel = buildVehicleLabel(savedSelections, fieldKeys, allFieldKeys);
              showResult(buildConfirmedHTML(vehicleLabel));
              bindChangeButtons();
              dispatchFitmentChange('fits', vehicleLabel);
              return;
            }

            manualVariantPick = false;   // fresh vehicle via cascade — auto-select allowed again
            verifyVehicle(productGid);
            startVariantMonitoring();
          }
        }

        // Bind change events
        fieldKeys.forEach(function(key, idx){
          if(!selects[key]) return;
          selects[key].addEventListener('change', function(){
            updateCascade(idx);
          });
        });

        var savedSelections = loadSavedSelection();

        function getProductHandle(){
          try {
            var path = window.location.pathname.split('/products/')[1];
            if(path) return path.split('?')[0].split('/')[0];
          } catch(e){}
          return null;
        }

        function getCustomFilterCacheKey(){
          var handle = getProductHandle();
          return handle ? 'ymm_custom_filter_' + handle : null;
        }

        function loadCachedCustomFilter(){
          try {
            var key = getCustomFilterCacheKey();
            if(!key) return null;
            var val = localStorage.getItem(key);
            return val ? JSON.parse(val) : null;
          } catch(e){ return null; }
        }

        function saveCustomFilterSelection(option){
          try {
            var key = getCustomFilterCacheKey();
            if(key) localStorage.setItem(key, JSON.stringify({ label: option.label, variantGid: option.variantGid, comingSoon: !!option.comingSoon, comingSoonMessage: option.comingSoonMessage || '' }));
          } catch(e){}
        }

        function getCurrentVariantId(){
          var variantId = null;
          var hiddenInput = document.querySelector('#jug-variant-id');
          if(hiddenInput && hiddenInput.value) variantId = hiddenInput.value;
          if(!variantId){
            var urlParams = new URLSearchParams(window.location.search);
            var urlVariant = urlParams.get('variant');
            if(urlVariant) variantId = urlVariant;
          }
          if(!variantId){
            var variantSelect = document.querySelector('select[name="id"]');
            if(variantSelect && variantSelect.value) variantId = variantSelect.value;
          }
          if(!variantId){
            var checkedRadio = document.querySelector('input[name="id"]:checked');
            if(checkedRadio && checkedRadio.value) variantId = checkedRadio.value;
          }
          if(!variantId){
            var selectedButton = document.querySelector('[name="id"][aria-checked="true"]');
            if(selectedButton && selectedButton.value) variantId = selectedButton.value;
          }
          if(!variantId){
            var formHiddenId = document.querySelector('form[action*="/cart/add"] input[name="id"][type="hidden"]');
            if(formHiddenId && formHiddenId.value) variantId = formHiddenId.value;
          }
          if(!variantId && window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.selectedVariantId){
            variantId = String(window.ShopifyAnalytics.meta.selectedVariantId);
          }
          return variantId;
        }

        var currentVerificationId = 0;

        // Build refinement UI for custom filter
        function buildRefinementHTML(customFilter, cachedSelection){
          var h = '<div class="ymm-v3-refinement" id="ymm-v3-refinement">';
          h += '<div class="ymm-v3-refinement__header">';
          h += '<div class="ymm-v3-refinement__icon">' + tuneIcon + '</div>';
          h += '<div>';
          h += '<div class="ymm-v3-refinement__title">We need a little more info</div>';
          h += '<div class="ymm-v3-refinement__sub">Select your ' + customFilter.label.toLowerCase() + ' for a precise fit</div>';
          h += '</div>';
          h += '</div>';
          h += '<div class="ymm-v3-refinement__selects" id="ymm-v3-refinement-selects">';
          h += '<select class="ymm-v3-fitment-select" id="ymm-v3-custom-filter">';
          h += '<option value="">' + customFilter.label + '</option>';
          for(var i = 0; i < customFilter.options.length; i++){
            var opt = customFilter.options[i];
            var selected = cachedSelection && cachedSelection.label === opt.label ? ' selected' : '';
            h += '<option value="' + i + '"' + selected + '>' + opt.label + '</option>';
          }
          h += '</select>';
          h += '</div>';
          h += '</div>';
          return h;
        }

        function bindCustomFilterSelect(customFilter, vehicleLabel, browseUrl, savedSelections, fieldKeys, allFieldKeys){
          var sel = root.querySelector('#ymm-v3-custom-filter');
          if(!sel) return;

          sel.addEventListener('change', function(){
            if(!sel.value) return;
            var idx = parseInt(sel.value, 10);
            var option = customFilter.options[idx];
            if(!option) return;

            sel.classList.add('active');
            saveCustomFilterSelection(option);

            var nameHTML = buildVehicleNameHTML(savedSelections, fieldKeys, allFieldKeys, option.label);

            if(option.comingSoon){
              var comingSoonMsg = option.comingSoonMessage || 'Get notified when this option becomes available for your vehicle.';
              var resultHTML = buildPendingHTML(vehicleLabel, nameHTML);
              resultHTML += '<div class="ymm-v3-coming-soon-card">'
                + '<div class="ymm-v3-coming-soon-card__title">' + option.label + ' — Coming Soon</div>'
                + '<div class="ymm-v3-coming-soon-card__text">' + comingSoonMsg + '</div>'
                + '<div class="ymm-v3-coming-soon-card__form" id="ymm-v3-coming-soon-form">'
                + '<input type="email" class="ymm-v3-coming-soon-card__input" placeholder="Enter your email" id="ymm-v3-coming-soon-email">'
                + '<button class="ymm-v3-coming-soon-card__btn" id="ymm-v3-coming-soon-btn">Notify Me</button>'
                + '</div>'
                + '</div>';
              resultHTML += '<a href="' + browseUrl + '" class="ymm-v3-fitment-browse-btn">'
                + searchIcon + ' View Products That Fit Your Vehicle ' + arrowIcon
                + '</a>';
              showResult(resultHTML);
              bindChangeButtons();
              bindComingSoonForm();
              dispatchFitmentChange('pending', vehicleLabel);
            } else if(option.variantGid){
              // Apply the variant FIRST — if any of the cosmetic rendering below
              // throws, the cart must already hold the right plate (8/10: the
              // confirmed card rendered while the variant never switched).
              var numericId = option.variantGid.split('/').pop();
              try { selectVariant(numericId); } catch(e){}
              var resultHTML = buildConfirmedHTML(vehicleLabel, nameHTML);
              showResult(resultHTML);
              bindChangeButtons();
              dispatchFitmentChange('fits', vehicleLabel);
            }
          });
        }

        function bindComingSoonForm(){
          var btn = root.querySelector('#ymm-v3-coming-soon-btn');
          var emailInput = root.querySelector('#ymm-v3-coming-soon-email');
          if(!btn || !emailInput) return;

          function submitSignup(){
            var email = emailInput.value.trim();
            if(!email || email.indexOf('@') === -1){
              emailInput.style.borderColor = '#ef4444';
              return;
            }

            btn.disabled = true;
            btn.textContent = 'Sending...';

            var currentVariantId = getCurrentVariantId();
            var varGid = currentVariantId ? 'gid://shopify/ProductVariant/' + currentVariantId : null;

            fetch('/apps/ymm/coming-soon-signup?shop=' + encodeURIComponent(shop), {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                email: email,
                productGid: productGid,
                variantGid: varGid,
                vehicleData: savedSelections
              })
            })
            .then(function(r){ return r.json(); })
            .then(function(data){
              var formEl = root.querySelector('#ymm-v3-coming-soon-form');
              if(formEl){
                formEl.innerHTML = '<div class="ymm-v3-coming-soon-card__success">You\'re on the list! We\'ll notify you when it\'s available.</div>';
              }
            })
            .catch(function(){
              btn.disabled = false;
              btn.textContent = 'Notify Me';
            });
          }

          btn.addEventListener('click', submitSignup);
          emailInput.addEventListener('keydown', function(e){
            if(e.key === 'Enter'){ e.preventDefault(); submitSignup(); }
          });
        }


        // Engine-aware variant picker (8/7). Mirrors the fitment-results scorer:
        // diesel/powerstroke/duramax/cummins and PowerBoost are hard constraints;
        // gas engines prefer a displacement match. Never returns a variant that
        // doesn't belong to the product on this page.
        var autoswapCount = 0;
        var inAutoswapVerify = false;
        // True once the USER manually picked a variant (engine button / select).
        // While set, verification only reports fit state — it never swaps the
        // variant out from under them. Cleared when a vehicle is (re)selected
        // through the YMM cascade.
        var manualVariantPick = false;
        function pickFittingVariant(gids, done){
          var ids = [];
          for(var i = 0; i < gids.length; i++){
            var n = String(gids[i]).split('/').pop();
            if(ids.indexOf(n) < 0) ids.push(n);
          }
          fetch(window.location.pathname + '.js')
            .then(function(r){ return r.json(); })
            .then(function(prod){
              var mine = [];
              try {
                window.__jugYmmTitles = window.__jugYmmTitles || {};
                for(var j = 0; j < prod.variants.length; j++){
                  window.__jugYmmTitles[String(prod.variants[j].id)] = String(prod.variants[j].title || '');
                }
              } catch(e){}
              for(var i = 0; i < ids.length; i++){
                for(var j = 0; j < prod.variants.length; j++){
                  if(String(prod.variants[j].id) === ids[i]) mine.push(prod.variants[j]);
                }
              }
              if(!mine.length){ done(null); return; }
              // No single-candidate shortcut: the app can return exactly ONE
              // wrong-engine variant, and the contradiction override below is
              // the only thing that catches it.
              var eng = '';
              try { eng = String((savedSelections && (savedSelections.Engine || savedSelections.engine)) || '').toLowerCase(); } catch(e){}
              var isDiesel = /diesel|powerstroke|duramax|cummins/.test(eng);
              var isBoost = eng.indexOf('powerboost') > -1;
              var disp = (eng.match(/\d\.\dl/) || [null])[0];
              // Bed preference: the vehicle's Bed Length field, or the bed the
              // shopper picked in the refinement step (cached custom filter).
              // The app ignores bed in matching (open app bug, 8/10), so without
              // this a long-bed truck kept the SHORT-bed fuel tank plate while
              // the banner said "Guaranteed to Fit".
              var bedPref = '';
              try {
                bedPref = String((savedSelections && savedSelections['Bed Length']) || '').toLowerCase();
                if(!bedPref){ var ccf = loadCachedCustomFilter(); bedPref = String((ccf && ccf.label) || '').toLowerCase(); }
              } catch(e){}
              var wantLong = bedPref.indexOf('long') > -1, wantShort = bedPref.indexOf('short') > -1;
              function scoreV(v){
                var t = String(v.title).toLowerCase(), sc = 0;
                var tDiesel = /diesel|powerstroke|duramax|cummins/.test(t);
                var tBoost = t.indexOf('boost') > -1;
                if(isBoost){ sc += tBoost ? 40 : -40; }
                else if(isDiesel){ sc += tDiesel ? 40 : -40; }
                else { if(tDiesel || tBoost) sc -= 40; if(disp && t.indexOf(disp) > -1) sc += 30; }
                var tLong = t.indexOf('long') > -1, tShort = t.indexOf('short') > -1;
                if((tLong || tShort) && (wantLong || wantShort)){
                  sc += ((wantLong && tLong) || (wantShort && tShort)) ? 25 : -25;
                }
                if(v.available === false) sc -= 10;
                return sc;
              }
              var best = mine[0], bestScore = -1e9;
              for(var i = 0; i < mine.length; i++){
                var sc = scoreV(mine[i]);
                if(sc > bestScore){ bestScore = sc; best = mine[i]; }
              }
              // The app's variant mappings are engine-agnostic on some SKUs — it can
              // hand back ONLY a contradicting variant (8/7: a 7.3L Gas F-250 got the
              // 6.7L Powerstroke variant as its sole "fit"). If every candidate
              // contradicts the vehicle's engine, rescore across ALL of this
              // product's variants and take the real engine match instead.
              if(bestScore < 0 && (isDiesel || isBoost || disp || wantLong || wantShort)){
                for(var i = 0; i < prod.variants.length; i++){
                  var sc = scoreV(prod.variants[i]);
                  if(sc > bestScore){ bestScore = sc; best = prod.variants[i]; }
                }
              }
              var currentBad = false;
              try {
                var cur = String(getCurrentVariantId() || '');
                for(var i = 0; i < prod.variants.length; i++){
                  if(String(prod.variants[i].id) === cur){
                    currentBad = (isDiesel || isBoost || disp || wantLong || wantShort) && scoreV(prod.variants[i]) < 0;
                  }
                }
              } catch(e){}
              done(String(best.id), currentBad);
            })
            .catch(function(){ done(null, false); });
        }

        function verifyVehicle(currentProductGid){
          // Fresh user-driven verification resets the autoswap oscillation cap.
          if(!inAutoswapVerify){ autoswapCount = 0; }
          inAutoswapVerify = false;
          if(!currentProductGid) return;
          currentVerificationId++;
          var thisVerificationId = currentVerificationId;
          var currentVariantId = getCurrentVariantId();

          showLoading();

          var vehicleLabel = buildVehicleLabel(savedSelections, fieldKeys, allFieldKeys);
          var vehicleJson = encodeURIComponent(JSON.stringify(savedSelections));
          var searchUrl = '/apps/ymm/search?productGid=' + encodeURIComponent(currentProductGid) + '&vehicle=' + vehicleJson;
          if(currentVariantId){
            var variantGid = 'gid://shopify/ProductVariant/' + currentVariantId;
            searchUrl += '&variantGid=' + encodeURIComponent(variantGid);
          }

          fetch(searchUrl)
            .then(function(r){ return r.json(); })
            .then(function(resp){
              if(thisVerificationId !== currentVerificationId) return;

              // If URL has no ?variant= but we know a fitting variant, update URL without reloading.
              // The app's variants list spans ALL matching products and is engine-agnostic on
              // some SKUs — variants[0] could be another product's variant, or the wrong engine
              // (a 7.3L Gas F-250 was getting the 6.7L Powerstroke variant, 8/7). Filter to THIS
              // product's variants and score against the vehicle's engine before selecting.
              var urlParams = new URLSearchParams(window.location.search);
              if(resp.variants && resp.variants.length > 0 && !manualVariantPick){
                var urlHasVariant = urlParams.has('variant');
                pickFittingVariant(resp.variants, function(vid, currentBad){
                  if(!vid) return;
                  if(resp.fits){
                    // No ?variant: free to apply the best fit. With ?variant (deep
                    // link / prior pick): respect it UNLESS it hard-contradicts the
                    // verified vehicle's engine — collection links carry first-variant
                    // params, which put diesel variants on gas trucks (8/7).
                    if(!urlHasVariant || currentBad){
                      if(String(vid) !== String(getCurrentVariantId() || '')) selectVariant(vid);
                    }
                  } else if(String(vid) !== String(getCurrentVariantId() || '')){
                    // Current variant doesn't fit but a sibling variant of THIS
                    // product does (e.g. vehicle changed gas→diesel while the URL
                    // still carries the gas variant). Swap to it and re-verify so
                    // the banner flips to confirmed. Capped to avoid oscillation
                    // if the app disagrees with its own suggestion.
                    autoswapCount = (autoswapCount || 0) + 1;
                    if(autoswapCount <= 2){
                      selectVariant(vid);
                      inAutoswapVerify = true;
                      verifyVehicle(currentProductGid);
                    }
                  }
                });
                // Don't return — continue processing the response to show confirmed state
              }

              var currentVariantFits = resp.fits === true;
              // Bed-honesty overlay: the app ignores Bed Length in matching
              // (open app bug, 8/10), so it answers "fits" for BOTH bed
              // variants. When we know the truck's bed — refinement pick or
              // vehicle field — and the current variant's title contradicts
              // it, the verdict is NOT a fit, whatever the app says.
              var bedOverlayApplied = false;
              var bhWantLong = false, bhWantShort = false;
              try {
                var bhBed = String((savedSelections && savedSelections['Bed Length']) || '').toLowerCase();
                if(!bhBed){ var bhc = loadCachedCustomFilter(); bhBed = String((bhc && bhc.label) || '').toLowerCase(); }
                bhWantLong = bhBed.indexOf('long') > -1; bhWantShort = bhBed.indexOf('short') > -1;
                if(currentVariantFits && (bhWantLong || bhWantShort)){
                  var bhCur = String((window.__jugYmmTitles || {})[String(getCurrentVariantId() || '')] || '').toLowerCase();
                  var bhL = bhCur.indexOf('long') > -1, bhS = bhCur.indexOf('short') > -1;
                  if((bhL || bhS) && !((bhWantLong && bhL) || (bhWantShort && bhS))){
                    currentVariantFits = false;
                    bedOverlayApplied = true;
                  }
                }
              } catch(e){}
              var alternative = resp.alternative || null;
              var variantsArray = (resp.variants || []).slice();
              // When the bed-honesty overlay flipped the verdict, the app's
              // variant list may hold only the (wrong-bed) queried variant —
              // synthesize right-bed same-fuel candidates from the product's
              // own variants so the shopper always gets a way out.
              if(bedOverlayApplied){
                try {
                  var bhAll = window.__jugYmmTitles || {};
                  var bhEng = String((savedSelections && (savedSelections.Engine || savedSelections.engine)) || '').toLowerCase();
                  var bhVehDiesel = /diesel|powerstroke|duramax|cummins/.test(bhEng);
                  Object.keys(bhAll).forEach(function(id){
                    var t = String(bhAll[id]).toLowerCase();
                    var okBed = (bhWantLong && t.indexOf('long') > -1) || (bhWantShort && t.indexOf('short') > -1);
                    var tDiesel = /diesel|powerstroke|duramax|cummins/.test(t);
                    if(okBed && tDiesel === bhVehDiesel) variantsArray.push('gid://shopify/ProductVariant/' + id);
                  });
                } catch(e){}
              }
              var otherVariantsFit = !currentVariantFits && Array.isArray(variantsArray) && variantsArray.length > 0;
              var customFilter = resp.customFilter || null;
              var cachedCustomFilter = loadCachedCustomFilter();


              var resultHTML = '';
              // Build multi-tag URL: /collections/all/9yy-year-2024+9yy-make-ford+9yy-model-f150
              var browseTags = [];
              fieldKeys.forEach(function(key){
                var val = savedSelections[key];
                if(val){
                  var slug = String(val).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
                  browseTags.push('9yy-' + key.toLowerCase() + '-' + slug);
                }
              });
              var browseUrl = '/collections/all/' + browseTags.join('+');

              if(currentVariantFits){
                // Show custom filter refinement if present and user hasn't selected yet
                if(customFilter && customFilter.options && customFilter.options.length > 0 && !cachedCustomFilter){
                  // Don't say "Guaranteed to Fit" yet — show pending state
                  var pendingNameHTML = buildVehicleNameHTML(savedSelections, fieldKeys, allFieldKeys);
                  resultHTML += buildPendingHTML(vehicleLabel, pendingNameHTML);
                  resultHTML += buildRefinementHTML(customFilter, cachedCustomFilter);
                } else if(cachedCustomFilter && cachedCustomFilter.comingSoon){
                  // Cached selection was coming soon — show pending + coming soon card + browse link
                  var comingSoonNameHTML = buildVehicleNameHTML(savedSelections, fieldKeys, allFieldKeys, cachedCustomFilter.label);
                  var comingSoonMsg = cachedCustomFilter.comingSoonMessage || 'Get notified when this option becomes available for your vehicle.';
                  resultHTML += buildPendingHTML(vehicleLabel, comingSoonNameHTML);
                  resultHTML += '<div class="ymm-v3-coming-soon-card">'
                    + '<div class="ymm-v3-coming-soon-card__title">' + cachedCustomFilter.label + ' — Coming Soon</div>'
                    + '<div class="ymm-v3-coming-soon-card__text">' + comingSoonMsg + '</div>'
                    + '<div class="ymm-v3-coming-soon-card__form" id="ymm-v3-coming-soon-form">'
                    + '<input type="email" class="ymm-v3-coming-soon-card__input" placeholder="Enter your email" id="ymm-v3-coming-soon-email">'
                    + '<button class="ymm-v3-coming-soon-card__btn" id="ymm-v3-coming-soon-btn">Notify Me</button>'
                    + '</div>'
                    + '</div>';
                  resultHTML += '<a href="' + browseUrl + '" class="ymm-v3-fitment-browse-btn">'
                    + searchIcon + ' View Products That Fit Your Vehicle ' + arrowIcon
                    + '</a>';
                } else {
                  var confirmedExtra = cachedCustomFilter ? cachedCustomFilter.label : null;
                  var confirmedNameHTML = buildVehicleNameHTML(savedSelections, fieldKeys, allFieldKeys, confirmedExtra);
                  resultHTML += buildConfirmedHTML(vehicleLabel, confirmedNameHTML);
                }

                if(alternative && alternative.name){
                  var altUrl = alternative.link || '#';
                  var altName = alternative.name;
                  var altDesc = alternative.description ? alternative.description.replace(/<[^>]*>/g, '') : '';
                  var altSavings = alternative.savings || '';
                  var altOrigPrice = alternative.origPrice || '';
                  var altBundlePrice = alternative.bundlePrice || '';

                  if(alternative.isUpsell){
                    resultHTML += '<a href="' + altUrl + '" class="ymm-v3-bundle-card ymm-v3-upgrade-link" data-cross-product="1">';
                    resultHTML += '<div class="ymm-v3-bundle-card__badge">' + bundleIcon + ' Bundle &amp; Save</div>';
                    resultHTML += '<div class="ymm-v3-bundle-card__title">' + altName + '</div>';
                    if(altDesc) resultHTML += '<div class="ymm-v3-bundle-card__desc">' + altDesc + '</div>';
                    if(altOrigPrice || altBundlePrice || altSavings){
                      resultHTML += '<div class="ymm-v3-bundle-card__pricing">';
                      if(altBundlePrice) resultHTML += '<span class="ymm-v3-bundle-card__price-new">' + formatPrice(altBundlePrice) + '</span>';
                      if(altOrigPrice) resultHTML += '<span class="ymm-v3-bundle-card__price-old">' + formatPrice(altOrigPrice) + '</span>';
                      if(altSavings) resultHTML += '<span class="ymm-v3-bundle-card__savings">' + altSavings + '</span>';
                      resultHTML += '</div>';
                    }
                    resultHTML += '<div class="ymm-v3-bundle-card__cta">' + arrowIcon + ' View Package Deal</div>';
                    resultHTML += '</a>';
                  } else {
                    resultHTML += '<div class="ymm-v3-upsell-card">';
                    resultHTML += '<div class="ymm-v3-upsell-card__header">' + altName + '</div>';
                    if(altDesc) resultHTML += '<div class="ymm-v3-upsell-card__text">' + altDesc + '</div>';
                    if(altOrigPrice || altBundlePrice){
                      resultHTML += '<div class="ymm-v3-upsell-card__text">';
                      if(altBundlePrice) resultHTML += '<span style="color:#22c55e;font-weight:700;font-size:18px">' + formatPrice(altBundlePrice) + '</span> ';
                      if(altOrigPrice) resultHTML += '<span style="text-decoration:line-through;color:#888">' + formatPrice(altOrigPrice) + '</span> ';
                      if(altSavings) resultHTML += '<span style="color:#22c55e;font-weight:600">' + altSavings + '</span>';
                      resultHTML += '</div>';
                    } else if(altSavings){
                      resultHTML += '<div class="ymm-v3-upsell-card__text" style="color:#22c55e;font-weight:600">' + altSavings + '</div>';
                    }
                    resultHTML += '<a href="' + altUrl + '" class="ymm-v3-upsell-card__link ymm-v3-upgrade-link" data-cross-product="1">';
                    resultHTML += arrowIcon + ' View Details';
                    resultHTML += '</a></div>';
                  }
                }

                showResult(resultHTML);
                var hasUnresolvedFilter = customFilter && customFilter.options && customFilter.options.length > 0 && !cachedCustomFilter;
                if(hasUnresolvedFilter) bindCustomFilterSelect(customFilter, vehicleLabel, browseUrl, savedSelections, fieldKeys, allFieldKeys);
                if(cachedCustomFilter && cachedCustomFilter.comingSoon) bindComingSoonForm();
                var fitState = hasUnresolvedFilter ? 'pending' : (cachedCustomFilter && cachedCustomFilter.comingSoon ? 'pending' : 'fits');
                dispatchFitmentChange(fitState, vehicleLabel);

              } else if(otherVariantsFit){
                // Show "doesn't fit this configuration" with options to switch
                var nameHTML = buildVehicleNameHTML(savedSelections, fieldKeys, allFieldKeys);
                resultHTML += '<div class="ymm-v3-vehicle-confirmed ymm-v3-vehicle-confirmed--warn">'
                  + '<div class="ymm-v3-vehicle-confirmed__icon">' + infoIcon + '</div>'
                  + '<div class="ymm-v3-vehicle-confirmed__info">'
                  + '<div class="ymm-v3-vehicle-confirmed__label">This Configuration Doesn\'t Fit</div>'
                  + '<div class="ymm-v3-vehicle-confirmed__name">' + (nameHTML || vehicleLabel) + '</div>'
                  + '</div>'
                  + '<button class="ymm-v3-vehicle-confirmed__change ymm-v3-change-trigger">Change ' + xIcon + '</button>'
                  + '</div>';

                // Build list of fitting variant options.
                // Dedupe (the app returns doubled rows on some SKUs) and, when
                // we know the bed — from the refinement cache or the vehicle —
                // drop options whose title contradicts it: the app ignores Bed
                // Length in matching, so it offers BOTH bed variants and one of
                // them is factually wrong for the truck (8/10).
                var variantTitles = resp.variantTitles || {};
                var seenFit = {}, fitList = [];
                var fitBedPref = '';
                try {
                  fitBedPref = String((savedSelections && savedSelections['Bed Length']) || '').toLowerCase();
                  if(!fitBedPref){ var fcf = loadCachedCustomFilter(); fitBedPref = String((fcf && fcf.label) || '').toLowerCase(); }
                  if(!fitBedPref){
                    // The shopper's own manual pick carries the bed: keep their
                    // bed, fix the contradicted dimension (engine).
                    var curT = String((window.__jugYmmTitles || {})[String(getCurrentVariantId() || '')] || '').toLowerCase();
                    if(curT.indexOf('long') > -1) fitBedPref = 'long';
                    else if(curT.indexOf('short') > -1) fitBedPref = 'short';
                  }
                } catch(e){}
                var fitWantLong = fitBedPref.indexOf('long') > -1, fitWantShort = fitBedPref.indexOf('short') > -1;
                var curFitVid = String(getCurrentVariantId() || '');
                for(var vi = 0; vi < variantsArray.length; vi++){
                  if(seenFit[variantsArray[vi]]) continue;
                  seenFit[variantsArray[vi]] = true;
                  // never suggest the variant that's already selected
                  if(String(variantsArray[vi]).split('/').pop() === curFitVid) continue;
                  fitList.push(variantsArray[vi]);
                }
                if(fitWantLong || fitWantShort){
                  var bedFiltered = fitList.filter(function(g){
                    var t = String(variantTitles[g] || '').toLowerCase();
                    var tL = t.indexOf('long') > -1, tS = t.indexOf('short') > -1;
                    if(!tL && !tS) return true;
                    return (fitWantLong && tL) || (fitWantShort && tS);
                  });
                  if(bedFiltered.length) fitList = bedFiltered;
                }
                resultHTML += '<div class="ymm-v3-fitment-result ymm-v3-fitment-result--no-fit">';
                resultHTML += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:16px;height:16px;"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>';
                resultHTML += '<div class="ymm-v3-fitment-result__text">The selected option is not compatible with your vehicle. These options fit:</div>';
                resultHTML += '</div>';

                resultHTML += '<div class="ymm-v3-fitting-options">';
                for(var vi = 0; vi < fitList.length; vi++){
                  var fitVid = fitList[vi].split('/').pop();
                  // fits-true responses carry no variantTitles (bed-honesty
                  // overlay path) — fall back to the product titles cached by
                  // the picker's product.js fetch.
                  var fitTitle = variantTitles[fitList[vi]] || (window.__jugYmmTitles || {})[fitVid] || ('Option ' + (vi + 1));
                  resultHTML += '<button class="ymm-v3-fitting-option-btn" data-variant-id="' + fitVid + '">'
                    + checkIcon + ' ' + fitTitle
                    + '</button>';
                }
                resultHTML += '</div>';

                showResult(resultHTML);
                bindChangeButtons();
                dispatchFitmentChange('no-fit', vehicleLabel);

                // Bind fitting option buttons
                resultEl.querySelectorAll('.ymm-v3-fitting-option-btn').forEach(function(btn){
                  btn.addEventListener('click', function(){
                    var vid = btn.getAttribute('data-variant-id');
                    if(vid) selectVariant(vid);
                  });
                });
                return;

              } else if(resp.comingSoon){
                // Product is marked as "coming soon" for this vehicle
                resultHTML += buildComingSoonHTML(vehicleLabel, resp.comingSoonMessage, browseUrl);

                showResult(resultHTML);
                bindComingSoonForm();
                bindChangeButtons();
                dispatchFitmentChange('coming-soon', vehicleLabel);

              } else {
                // No fit — show no-fit banner
                resultHTML += buildNoFitHTML(vehicleLabel);
                resultHTML += '<div class="ymm-v3-fitment-result ymm-v3-fitment-result--no-fit">';
                resultHTML += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:16px;height:16px;"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>';
                resultHTML += '<div class="ymm-v3-fitment-result__text">This product is not compatible with your vehicle</div>';
                resultHTML += '</div>';
                resultHTML += '<a href="' + browseUrl + '" class="ymm-v3-fitment-browse-btn">';
                resultHTML += searchIcon + ' View Products That Fit Your Vehicle ' + arrowIcon;
                resultHTML += '</a>';

                showResult(resultHTML);
                dispatchFitmentChange('no-fit', vehicleLabel);
              }

              bindChangeButtons();

              // Bind upgrade/bundle link handlers
              resultEl.querySelectorAll('.ymm-v3-upgrade-link').forEach(function(link){
                link.addEventListener('click', function(e){
                  e.preventDefault();
                  var href = link.getAttribute('href');

                  try {
                    var trackParams = 'shop=' + encodeURIComponent(shop)
                      + '&productGid=' + encodeURIComponent(productGid || '')
                      + '&targetUrl=' + encodeURIComponent(href || '');
                    var variantMatch2 = window.location.search.match(/variant=(\d+)/);
                    if(variantMatch2) trackParams += '&variantGid=' + encodeURIComponent('gid://shopify/ProductVariant/' + variantMatch2[1]);
                    var trackBody = {};
                    try { trackBody = { vehicle: savedSelections || {} }; } catch(te){}
                    fetch('/apps/ymm/track-upsell?' + trackParams, {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify(trackBody)
                    }).catch(function(){});
                  } catch(trackErr){}

                  window.location.href = href;
                });
              });
            })
            .catch(function(err){
              if(thisVerificationId !== currentVerificationId) return;
              showResult('<div class="ymm-v3-vehicle-confirmed ymm-v3-vehicle-confirmed--nofit">'
                + '<div class="ymm-v3-vehicle-confirmed__icon">' + infoIcon + '</div>'
                + '<div class="ymm-v3-vehicle-confirmed__info">'
                + '<div class="ymm-v3-vehicle-confirmed__label">Error checking fitment</div>'
                + '<div class="ymm-v3-vehicle-confirmed__name">Please try again</div>'
                + '</div></div>');
            });
        }

        // Y3: initial verification for a saved vehicle now runs through the
        // restore-into-selects path below (for BOTH PDP and non-PDP), so the
        // dropdowns are pre-filled and ready for edit-in-place. The cascade's
        // auto-verify handles the PDP verifyVehicle() call.

        // Variant monitoring
        var variantMonitoringStarted = false;

        function startVariantMonitoring(){
          if(variantMonitoringStarted) return;
          variantMonitoringStarted = true;

          var lastCheckedVariantId = getCurrentVariantId();
          var lastCheckedUrl = window.location.href;

          function checkForVariantChange(source){
            if(!productGid) return;
            var currentUrl = window.location.href;
            var currentVariantId = getCurrentVariantId();
            if(currentUrl !== lastCheckedUrl) lastCheckedUrl = currentUrl;
            if(currentVariantId && currentVariantId !== lastCheckedVariantId){
              lastCheckedVariantId = currentVariantId;
              if(String(currentVariantId) !== String(window.__jugYmmProgVid || '')){
                manualVariantPick = true;
              }
              showLoading();
              verifyVehicle(productGid);
            }
          }

          setInterval(function(){ checkForVariantChange('polling'); }, 300);

          var originalPushState = history.pushState;
          var originalReplaceState = history.replaceState;
          history.pushState = function(){
            originalPushState.apply(history, arguments);
            setTimeout(function(){ checkForVariantChange('pushState'); }, 10);
          };
          history.replaceState = function(){
            originalReplaceState.apply(history, arguments);
            setTimeout(function(){ checkForVariantChange('replaceState'); }, 10);
          };
          window.addEventListener('popstate', function(){
            setTimeout(function(){ checkForVariantChange('popstate'); }, 10);
          });

          try {
            var mutationTargets = [];
            var jugHidden = document.querySelector('#jug-variant-id');
            if(jugHidden) mutationTargets.push(jugHidden);
            var productForm = document.querySelector('form[action*="/cart/add"]');
            if(productForm) mutationTargets.push(productForm);

            if(mutationTargets.length > 0){
              var observer = new MutationObserver(function(){
                setTimeout(function(){ checkForVariantChange('mutation'); }, 50);
              });
              mutationTargets.forEach(function(target){
                observer.observe(target, { attributes: true, childList: true, subtree: true, characterData: true });
              });
            }

            document.querySelectorAll('input[name="id"], select[name="id"], [name="id"]').forEach(function(el){
              el.addEventListener('change', function(){ setTimeout(function(){ checkForVariantChange('input-change'); }, 50); });
            });

            document.querySelectorAll('[data-option-index], [data-value], .swatch, .variant-swatch, .option-swatch, .product-option, .jug-option-btn, .jug-swatch, [class*="variant"], [class*="option"]').forEach(function(el){
              el.addEventListener('click', function(){
                setTimeout(function(){ checkForVariantChange('swatch-click'); }, 150);
                setTimeout(function(){ checkForVariantChange('swatch-click-delayed'); }, 500);
              });
            });
          } catch(e){
          }
        }

        if(savedSelections){
          startVariantMonitoring();
        }

        // Restore saved selections when no product to verify
        if(savedSelections && selectsContainer){
          function restoreField(idx){
            if(idx >= fieldKeys.length) return;
            var key = fieldKeys[idx];
            if(savedSelections[key]){
              var optionExists = false;
              for(var i = 0; i < selects[key].options.length; i++){
                if(selects[key].options[i].value === savedSelections[key]){ optionExists = true; break; }
              }
              if(optionExists){
                selects[key].value = savedSelections[key];
                updateCascade(idx);
                setTimeout(function(){ restoreField(idx + 1); }, 50);
              }
            } else { restoreField(idx + 1); }
          }
          restoreField(0);
          // Fallback: if the saved vehicle can't be fully restored into the
          // dropdowns (a value is no longer a valid option), still verify with
          // the saved selection directly so a PDP never hangs on the spinner.
          // Runs after the async restore chain (50ms x fields) has settled;
          // skips if restore completed (auto-verify already fired).
          if(productGid){
            setTimeout(function(){
              if(!checkAllFieldsFilled()){
                manualVariantPick = false;
                verifyVehicle(productGid);
                startVariantMonitoring();
              }
            }, 500);
          }
        }
    }
  })();
